import styled from "styled-components/macro";

export const StyledGraceCTA = styled.div`
  background: var(--container-color);
  border-radius: 40px;
  padding: 5px;
  display: flex;
  justify-content: space-between;
  margin: 25px auto;
  width: 800px;

  p {
    display: block;
    align-self: center;
    font-size: 16px;
    color: var(--grey-1);
    line-height: 130% !important;
    font-weight: 500;
    a {
      color: #444;
      text-decoration: underline;
    }
  }

  img {
    /* width: 150px; */
    height: 80px;
    align-self: center;
    margin-right: -12px;
    transform: scale(1.5);
  }

  button {
    margin-top: 0 !important;
    margin-left: 20px;
    align-self: center;
    min-width: 140px;
    margin-right: 20px;
    padding: 8px 20px !important;
    white-space: nowrap;
  }

  .left-container {
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }

  &.sw2 {
    background: var(--menu-color);
    border-radius: 24px;
    box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.15), 0px 0px 2px 0px rgba(0, 0, 0, 0.25);
    padding: 16px 16px 16px 19px;
    margin: 0 16px 16px 16px;
    width: auto;

    p {
      font-size: 15px;
    }

    button {
      padding: 7px 12px !important;
      border-radius: 10px !important;
      margin: 0;
      min-width: fit-content;
      border: 2px solid var(--primary-cta) !important; // so it matches the size of secondary CTA
    }

    &.show-coins {
      img {
        height: 30px;
        transform: scale(2.25) translateX(8px);
        margin-right: 45px;
      }
    }
  }
`;
